var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5.5l-1.05 1.05 5.625 5.7H.25v1.5h15.825l-5.625 5.7 1.05 1.05L19 8 11.5.5z",
    fill: "#351CAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default "/_next/static/images/a4bbc1ba3e8d3cf5448603970ef6f580.svg";
export { ForwardRef as ReactComponent };